import { render, staticRenderFns } from "./CrearEditarColaborador.vue?vue&type=template&id=0bc8bf62"
import script from "./CrearEditarColaborador.vue?vue&type=script&lang=js"
export * from "./CrearEditarColaborador.vue?vue&type=script&lang=js"
import style0 from "./CrearEditarColaborador.vue?vue&type=style&index=0&id=0bc8bf62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports